module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_05_american-village-0584312649945dca332aea7a656727f2.jpg";